import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Fabworks from './pages/Fabworks';
import RivalRobots from './pages/RivalRobots';
import MarkdownPage from './pages/MarkdownPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/fabworks" element={<Fabworks />} />
        <Route path="/rival" element={<RivalRobots />} />
        <Route path="/rival/:robotName" element={<MarkdownPage />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App; 